// extracted by mini-css-extract-plugin
export default {"Input":"Input_Input__OO8z2"};